
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
:host{
  display:block;
}

.search-bar .search-label {
  margin-bottom:0.5rem;
}

.search-bar .search-label {
  display:block;
}

.search-bar .search-label {
  font-weight:var(--fw-semibold);
}

:host([site='GHS']) .search-bar .search-label {
  margin-top:1rem;
}

:host([site='GHS']) .search-bar .search-label {
  font-family:var(--ff-body);
}

:host([site='GHS']) .search-bar .search-label {
  color:var(--primary-blue);
}

@media (min-width: 1024px) {

  :host([site='GHS']) .search-bar .search-label {
    display:none;
  }
}

:host([site='BH']) .search-bar {
  margin:auto;
}

@media (min-width: 640px) {

  :host([site='BH']) .search-bar {
    max-width:640px;
  }
}

@media (min-width: 768px) {

  :host([site='BH']) .search-bar {
    max-width:48rem;
  }
}

@media (min-width: 1024px) {

  :host([site='BH']) .search-bar {
    max-width:64rem;
  }
}

:host([site='BH']) .search-bar .search-label {
  font-family:var(--bh-ff-body);
}

:host([site='BH']) .search-bar .search-label {
  color:var(--bh-neutral-darker);
}

:host([site='BH']) .search-bar .close {
  margin-left:auto;
}

:host([site='BH']) .search-bar .close {
  display:block;
}

:host([site='BH']) .search-bar .close {
  cursor:pointer;
}

:host([site='BH']) .search-bar .close {
  border-width:0px;
}

:host([site='BH']) .search-bar .close {
  background-color:var(--neutral-transparent);
}

:host([site='BH']) .search-bar .close {
  color:var(--bh-brand-primary-default);
}

:host([site='BH']) .search-bar .close:hover, :host([site='BH']) .search-bar .close:focus, :host([site='BH']) .search-bar .close:focus-within {
  color:var(--bh-brand-primary-light);
}

:host([site='BH']) .search-bar .search-bar-form-wrapper {
  display:flex;
}

:host([site='BH']) .search-bar .search-bar-form-wrapper {
  width:100%;
}

:host([site='BH']) .search-bar .search-bar-form-wrapper {
  overflow:hidden;
}

:host([site='BH']) .search-bar .search-bar-form-wrapper ::slotted(*) {
  margin:0px !important;
}

:host([site='BH']) .search-bar .search-bar-form-wrapper ::slotted(*) {
  flex:1 1 0%;
}

:host([site='BH']) .search-bar .search-bar-form-wrapper ::slotted(*) {
  padding:0px !important;
}

@media (min-width: 1024px) {

  :host([site='BH']) .search-bar .search-bar-form-wrapper ::slotted(*) {
    flex-direction:column;
  }
}
`;